import { myListsDetailsOptionsStyles } from "@insite/content-library/Widgets/MyListsDetails/MyListsDetailsOptions";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Search from "@insite/mobius/Icons/Search";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { COLORS, TYPOGRAPHY } from "@tecumseh/theme/design";
import { css } from "styled-components";

myListsDetailsOptionsStyles.search = {
    iconProps: { src: Search },
    cssOverrides: {
        formField: css`
            > div[class^="FormInputWrapper"] {
                input {
                    padding-right: 30px;
                }
            }
        `,
    },
}

myListsDetailsOptionsStyles.productSelectorStyles = {
    selectButton: {
        css: css`
            margin-top: 30px;
            border-radius: 25px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                            width: 100%;
                        `,
                    ],
                    "max",
                )}
        `,
    },
}

myListsDetailsOptionsStyles.orderUploadStyles = {
    cancelUploadButton: {
        variant: "primary",
        css: css`
            float: right;
            border-radius: 25px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            width: 100%;
                        `,
                    ],
                    "max",
                )}
        `,
    },
    uploadFileButton: {
        css: css`
            float: right;
            border-radius: 25px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            margin-bottom: 10px;
                            width: 100%;
                        `,
                        css`
                            margin-left: 15px;
                            width: initial;
                        `,
                    ],
                    "min",
                )}
        `,
    },
    downloadTemplateButton: {
        css: css`
            margin-bottom: 15px;
            border-radius: 25px;
        `,
        variant: "primary",
    },
    fileUploader: {
        buttonProps: {
            variant: "primary",
            css: css`
                border-radius: 25px;
            `,
        },
    },
}